import { useState, FC } from 'react'
import classNames from 'classnames'

import styles from './Venue.module.scss'

import { SectionLayout } from 'components'
import { GOOGLE_MAPS_URL } from 'types'

interface VenueProps {
  isEdition?: boolean
  addToRefs?: (el: HTMLDivElement) => void
}

const Venue: FC<VenueProps> = ({ addToRefs, isEdition }) => {
  const [activePart, setActivePart] = useState<number>(0)

  const activeHandler = (index: number) => {
    setActivePart(index)
  }

  return (
    <SectionLayout addToRefs={addToRefs} id='VENUE'>
      <div className={'container'}>
        <div className={styles.three__content}>
          <div className={styles.three__content_left}>
            <div className={styles.three__content_left__map}>
              <iframe src={GOOGLE_MAPS_URL} width='600' height='450' loading='lazy' />
            </div>
          </div>

          <div className={styles.three__content_right}>
            <div
              role='button'
              onClick={() => activeHandler(0)}
              className={classNames(styles.three__content_right__item, {
                [styles.three__content_right__item_active]: activePart === 0,
              })}
            >
              <div className={styles.three__content_right__item_left}>
                <p className={styles.three__content_right__item_left_name}>Venue</p>
                <p className={styles.three__content_right__item_left_date}>
                  {isEdition ? 'Sep 14, 2024' : 'May 24, 2025'}
                </p>
              </div>

              <div className={styles.three__content_right__item_right}>
                <span className={styles.three__content_right__item_right_title}>American University of Armenia</span>
                <span>40 Marshal Baghramyan Ave, </span>
                <span>Yerevan 0019</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionLayout>
  )
}

export default Venue
